import { Link, useNavigate } from 'react-router-dom';
import StudyOption from '../AllData/HomeData';
import './../../pagescss/Home.css';
import TopNavbar from './TopNavbar';
import { useEffect, useState } from 'react';
import useUsersData from '../Auth/AllUsers';
import { API_CONFIG } from './../../config';
import UsePayments from '../AdminPanel/UsePayments';
import UsePaymentItems from '../AdminPanel/UsePaymentItems';
import PaidItems from "../AllData/PaidItems";

const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.APPINSTALLSEND}`;

const PUSH_APPITEMSUSE = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.APPITEMSUSEPUSH}`;


function Home() {
  const { users, loading } = useUsersData();
  const studyOptions = StudyOption;
  const activeOptions = studyOptions.filter(option => option.status === "true");
  const [paymentStatus, setPaymentStatus] = useState(false);
  const { allPayments, paymentLoading } = UsePayments();

  const userPhone = localStorage.getItem('userPhone');

  const targetUser = users.find(user => user.phone === userPhone);
  const userName = targetUser?.name;
  const userEmail = targetUser?.email;
  const userClass = targetUser?.class;
  const registerDate = targetUser?.registar_date;
  const lastLogin = targetUser?.last_login;

  var name = userName || "to NEET Prep App";

  const { paymentItems } = UsePaymentItems();

  useEffect(() => {
    const hasPayment = allPayments.some(
      payment => payment.phone === userPhone
    );
    setPaymentStatus(hasPayment);
  }, [allPayments, userPhone]);


  const targetPayment = allPayments.find(payment => payment.phone === userPhone);
  const buyItem = targetPayment?.buyed;
  const itemPrice = targetPayment?.amount;

  const targetPaymentItem = paymentItems.find(paymentItem => paymentItem.itemId == buyItem);
  const itemName = targetPaymentItem?.name;
  const itemAbout = targetPaymentItem?.about;
  const itemValid = targetPaymentItem?.valid;
  const itemYear = targetPaymentItem?.year;


  if (userPhone && !loading && !paymentLoading) {

    localStorage.setItem('userPhone', userPhone);
    localStorage.setItem('userEmail', userEmail);
    localStorage.setItem('userName', userName);
    localStorage.setItem('userClass', userClass);
    localStorage.setItem('registerDate', registerDate);
    localStorage.setItem('lastLogin', lastLogin);


    if (paymentStatus) {

      localStorage.setItem('userPayment', userPhone);

      localStorage.setItem('itemName', itemName);
      localStorage.setItem('itemPrice', itemPrice);
      localStorage.setItem('itemAbout', itemAbout);
      localStorage.setItem('itemValid', itemValid);
      localStorage.setItem('itemYear', itemYear);

    } else {
      localStorage.setItem('userPayment', '');

    }

  }

  const userPayment = localStorage.getItem('userPayment');


  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);

    const handleBackButton = () => {
      window.history.pushState(null, null, window.location.pathname);
    };
    window.addEventListener('popstate', handleBackButton);
    return () => window.removeEventListener('popstate', handleBackButton);

  }, []);


  useEffect(() => {
    const trackNewUser = async () => {
      if (!localStorage.getItem('tracked')) {
        const generatedId = 'USER-' + Math.random().toString(36).substr(2, 9).toUpperCase();
        try {
          const response = await fetch(CREATE_USER_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'userId=' + encodeURIComponent(generatedId)
          });

          if (response.ok) {
            localStorage.setItem('tracked', 'true');
            console.log("User Tracked:", generatedId);
          }
        } catch (error) {
          console.error("Tracking error:", error);
        }
      }
    };

    trackNewUser();
  }, []);




  // 1. Updated ItemClick function to take the 'option' object dynamically
  const ItemClick = async (option) => {
    const formData = {
      name: option.name,
      type: option.id
    };

    try {
      await fetch(PUSH_APPITEMSUSE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.error('Submission error:', error.message);
    }
  };






  return (
    <div className="study-app">

      <TopNavbar name={name} />

      <header className="app-header">
        <h1>🎯 NEET UG → 🩺 MBBS</h1>

    {userPayment ? (<></>):(<><p><strong>🎉 One Subscription. Everything Unlocked! </strong></p></>)}
      </header>



      <div className="study-grid">
        {activeOptions.map((option) => {

          // Check whether this item's type is in PaidItems
          const isPaid = PaidItems.includes(option.id);

          return (
            <Link
              to={option.link}
              key={option.id}
              className="study-card-link"
              onClick={() => ItemClick(option)}
            >
              <div
                className="study-card"
                style={{ position: 'relative' }}
              >

                {userPayment || option.id == "bookmarkedquestions" || option.id == "bookmarkedpdfs" || option.id == "questionshistory" || option.id == "subjectprogress" ? (<></>) : (<>
                  <span
                    style={{
                      position: 'absolute',
                      top: '5px',
                      right: '5px',
                      padding: '4px 10px',
                      borderRadius: '12px',
                      fontSize: '10px',
                      fontWeight: 'bold',
                      backgroundColor: isPaid
                        ? '#ffe0e0'
                        : '#dff7e3',
                      color: isPaid
                        ? '#d60000'
                        : '#087f23',
                      zIndex: 2
                    }}
                  >
                    {isPaid ? 'Paid' : 'Free'}
                  </span>
                </>)}



                <div className="card-icon">
                  <span style={{ fontSize: '70px' }}>
                    {option.symbol}
                  </span>
                </div>

                <h3>{option.name}</h3>

              </div>
            </Link>
          );
        })}
      </div>

      <br />

    </div>
  );
}

export default Home;